import { useState, useEffect, useRef } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const REFRESH_INTERVAL_MS = 20 * 1000;

export const useAvailableSeats = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasLoadedOnceRef = useRef(false);

  useEffect(() => {
    const fetchSeats = async () => {
      if (!hasLoadedOnceRef.current) setLoading(true);
      setError(null);

      try {
        if (process.env.NODE_ENV === 'development') {
                  }
        const response = await fetch(`${API_BASE_URL}/api/pricing/available-seats`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        if (result.success && result.data) {
          const raw = result.data;
          const data = {
            ...raw,
            earlyBird: raw.earlyBird ?? raw.early_bird,
            discount268: raw.discount268 ?? raw.discount_268,
          };
          // Cardul Discount 270€ cere `discount268.available` numeric; altfel UI poate afișa „null” / NaN
          const d268 = data.discount268;
          const parsed =
            d268 != null && typeof d268 === 'object' ? Number(d268.available) : NaN;
          if (!Number.isFinite(parsed)) {
            data.discount268 = {
              available: 19,
              total: 19,
              sold: 0,
              name: 'Discount',
              price: 270,
            };
          }
          if (process.env.NODE_ENV === 'development') {
                      }
          setData(data);
        } else {
          throw new Error(result.error || 'Failed to fetch available seats');
        }
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
                  }
        setError(err instanceof Error ? err.message : 'Failed to fetch available seats');
        
        // Fallback dacă API eșuează — include discount268 ca să nu apară „null” pe card
        const fallbackData = {
          standard: { available: 3100 },
          vip: { available: 750 },
          ultraVip: { available: 150 },
          discount268: { available: 19, total: 19, sold: 0, name: 'Early Bird', price: 270 },
        };
        setData(fallbackData);
      } finally {
        hasLoadedOnceRef.current = true;
        setLoading(false);
      }
    };

    fetchSeats();
    const interval = setInterval(fetchSeats, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return { data, loading, error };
};





